/** Check if a key is a valid key of an object */
export function isValidKey<T extends Record<string, unknown>>(
  key: string,
  obj: T
): key is Extract<keyof T, string> {
  return key in obj;
}
